/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_Li_Maintenance_LabelInputs */

const tr_servis_s4_li_maintenance_label = /** @type {(inputs: Servis_S4_Li_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlı bakım:`)
};

const en_servis_s4_li_maintenance_label = /** @type {(inputs: Servis_S4_Li_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned maintenance:`)
};

const de_servis_s4_li_maintenance_label = /** @type {(inputs: Servis_S4_Li_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplante Wartung:`)
};

const ru_servis_s4_li_maintenance_label = /** @type {(inputs: Servis_S4_Li_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плановые работы:`)
};

/**
* | output |
* | --- |
* | "Planned maintenance:" |
*
* @param {Servis_S4_Li_Maintenance_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_li_maintenance_label = /** @type {((inputs?: Servis_S4_Li_Maintenance_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_Li_Maintenance_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_li_maintenance_label(inputs)
	if (locale === "de") return de_servis_s4_li_maintenance_label(inputs)
	if (locale === "ru") return ru_servis_s4_li_maintenance_label(inputs)
	return tr_servis_s4_li_maintenance_label(inputs)
});